import { render } from "./MassEdit.vue?vue&type=template&id=289e452e"
import script from "./MassEdit.vue?vue&type=script&lang=js"
export * from "./MassEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/christian/dev/pingcrm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__